// src/utils/meiliClient.ts
import { MeiliSearch } from "meilisearch";

/**
 * Reads environment variables using the webpack/Create React App method.
 */
const HOST =
  process.env.REACT_APP_MEILI_URL ||
  "https://millisearch-hireenumerator.duckdns.org/";

const KEY = process.env.REACT_APP_MEILI_KEY;

export const meiliClient = new MeiliSearch({
  host: HOST,
  apiKey: KEY,
});